import Vue from 'vue'
import Router from "vue-router";
import Userauth from '../auth/js/index'
import { authHeader } from '../_helpers/auth-header'

import Body from '../components/body'
import Auth from '../auth/auth'
import { userService } from '../_services';

// import { store } from '../store'

// import VueJwtDecode from "vue-jwt-decode";

// import SamplePage from '../pages/sample_page'
import Dashboard from '../pages/dashboard'

/* Auth */
import Login from '../auth/login'
import Register from '../auth/register'
// import callback from '../pages/callback'

/* Patient */
// import PatientList from '../pages/patient/patientlist'
import VendorList from '../pages/vendors/vendorlist'
import VendorReport from '../pages/vendors/vendorreport'
import UserList from '../pages/users/userlist'
import UserReport from '../pages/users/userreport'
import CourierList from '../pages/couriers/courierlist'
import OrderList from '../pages/orders/orderlist'
import OrderReport from '../pages/orders/orderreport'

import Setting from '../pages/setting'
import Slider from '../pages/sliders'

/* User */
import adduser from '../auth/adduser'


// component

Vue.use(Router)

const routes = [
  { path: '', redirect: { name: 'dashboard' }},
  { path: '/', redirect: { name: 'dashboard' }},
  { path: '/sliders', redirect: { name: 'slider' }},
  {
    path: '/dashboard',
    component: Body,
    children: [
    {
      path: 'default',
      name: 'dashboard',
      component: Dashboard,
      meta: {
        title: 'Default Dashboard | Admin',
      }
    }
    ]
  },
  {
    path: '/setting',
    name: 'setting',
    component: Body,
    children: [
    {
      path: '',
      name: 'setting',
      component: Setting,
      meta: {
        title: 'Setting',
      }
    }
    ]
  },
  {
    path: '/sliders',
    name: 'Sliders',
    component: Body,
    children: [
    {
      path: '',
      name: 'slider',
      component: Slider,
      meta: {
        title: 'Slider',
      }
    }
    ]
  },
  {
    path: '/auth',
    component: Auth,
    children: [
      {
        path: 'login',
        name: 'login',
        component: Login,
        meta: {
          title: 'Auth | Login',
        }
      },
      {
        path: 'register',
        name: 'register',
        component: Register,
        meta: {
          title: 'Auth | Register',
        }
      },
      {
        path: 'forgotpassword',
        name: 'forgot-password',
        component: Login,
        meta: {
          title: 'Auth | Login',
        }
      }
    ]
  },
  {
    path: '/user',
    component: Body,
    children: [
      {
        path: 'adduser',
        name: 'adduser',
        component: adduser,
        meta: {
          title: 'User | Add User',
        }
      },
      {
        path: 'resetuser',
        name: 'resetuser',
        component: adduser,
        meta: {
          title: 'User | Reset User',
        }
      },
      {
        path: 'changepassword',
        name: 'changepassword',
        component: adduser,
        meta: {
          title: 'User | Change Password',
        }
      }
    ]
  },
  {
    path: '/users',
    component: Body,
    children: [
      {
        path: 'userlist',
        name: 'user-list',
        component: UserList,
        meta: {
          title: 'User List',
        }
      },
      {
        path: 'userreport',
        name: 'user-report',
        component: UserReport,
        meta: {
          title: 'User Report',
        }
      }
    ]
  },
  {
    path: '/orders',
    component: Body,
    children: [
      {
        path: 'orderlist',
        name: 'order-list',
        component: OrderList,
        meta: {
          title: 'Order List',
        }
      },
      {
        path: 'orderreport',
        name: 'order-report',
        component: OrderReport,
        meta: {
          title: 'Order Report',
        }
      }
    ]
  },
  {
    path: '/vendors',
    component: Body,
    children: [
      {
        path: 'vendorlist',
        name: 'vendor-list',
        component: VendorList,
        meta: {
          title: 'Vendor List',
        }
      },
      {
        path: 'vendorreport',
        name: 'vendor-report',
        component: VendorReport,
        meta: {
          title: 'Vendor Report',
        }
      }
    ]
  },
  {
    path: '/couriers',
    component: Body,
    children: [
      {
        path: 'courierlist',
        name: 'courier-list',
        component: CourierList,
        meta: {
          title: 'Courier List',
        }
      },
      {
        path: 'courierreport',
        name: 'courier-report',
        component: VendorReport,
        meta: {
          title: 'Courier Report',
        }
      }
    ]
  },
];

const router = new Router({
  routes,
  base: '/',
  mode: 'history',
  linkActiveClass: "active",
  scrollBehavior () {
    return { x: 0, y: 0 }
  }
});


// configure axios 
const axios = require('axios')

// token
let token = authHeader()['Authorization']

// window.axios= axios.create({
//   baseURL: `http://localhost:4000/api/`,
//   headers: {
//     Authoization: `Bearer ${token}`
//   }
// })

// set default 
axios.defaults.baseURL = 'https://greenserver.fly.dev/rest/'
axios.defaults.headers.common['Authorization'] = token

// authenticate 
router.beforeEach((to, from, next) => {
    
    // user
    const User = localStorage.getItem('user')

    if (['/auth/login','/auth/register'].includes(to.path) || (User && Userauth.isAuthenticated())){
      return next();
    } else {
      //
      // user
      const User = JSON.parse(localStorage.getItem('user'))
      // validate
      if (!User) {
          return next('/auth/login')
      }
      // initiate a refresh request
      userService.refresh(User.refresh_token).then(()=>{
          //
          if (['/auth/login','/auth/register'].includes(to.path) || (User && Userauth.isAuthenticated())) {
              return next();
          }

      }).catch( ()=>{
          //
          Userauth.logOut()
          //
          return next('/auth/login')
       })
    }

    // check token expiry
    
    // decode jwt token
    // axios.get('/user').then( () => {
    //   // token is valid
    //   // console.log(res.data)
    //   const User = localStorage.getItem('user')

    //   const  path = ['/auth/login','/auth/register'];
    //   if (path.includes(to.path) || to.path === "/callback" || User || Userauth.isAuthenticatedUser()){
    //     return next();
    //   }
      
    //   next('/auth/login')

    // })
    // .catch( () => {
    //   // initiate a refresh request
    //   store.dispatch("authentication/refresh", { token, refresh_token })
    //   // wait
    //   setTimeout(() =>{

    //     if (store.state.authentication.status.refreshedToken == true ){

    //       const User = localStorage.getItem('user')

    //       if (['/auth/login','/auth/register'].includes(to.path) || to.path === "/callback" || User || Userauth.isAuthenticatedUser()){
    //         return next();
    //       }
          
    //       next('/auth/login')
    //     }
        
    //     // set new token
    //     // axios.defaults.headers.common['Authorization'] = authHeader()['Authorization']
        
    //   }, 450)
    // })

    // if(to.meta.title)
      // document.title = to.meta.title;

    
});


export default router
